export const environment = {
  production: true,
  branch: 'master',
  commit: 'a9d35fd31d6b542db8ab094acec31978fbbf210e',
  date: 'Friday 09/18/2026 16:03 -04:00',
  version: '2.1.14',
  backendApiUrl: '#{ofv_api}#',
  inactivityTimeLimitInMinutes: '#{inactivity_time_limit_in_minutes}#',
  inactivityLogoutTimeInSeconds: '#{inactivity_logout_time_in_seconds}#',
  refreshNotificationsInIntervalsPerMinute:
    '#{refresh_notifications_in_intervals_per_minute}#',
  userInfoStorageKey: '#{user_info_Storage_Key}#',
  clientId: '#{client_id}#',
  appCode: '#{app_code}#',
  externalLinks: {
    subscriptionLink: '#{subscription_link}#',
    slideImagesLink: '#{slide_images_link}#',
    generalQuoterLink: '#{general_quoter_link}#',
    travelQuoterLink: '#{travel_quoter_link}#',
    vehicleClaimLink: '#{vehicle_claim_link}#',
    healthClaimLink: '#{health_claim_link}#',
    ethicalLineLink: '#{ethical_line_link}#',
    vehicleQuoterLink: '#{vehicle_quoter_link}#',
    suretyQuoterLink: '#{surety_quoter_link}#',
  },
  /**Variables de google analytics */
  ga_measurement_id_oficina_virtual: '#{ga_measurement_id_oficina_virtual}#',
  ga_debug_mode_oficina_virtual: '#{ga_debug_mode_oficina_virtual}#',
};
